import { Box, Skeleton, Stack, Typography } from "@mui/joy";
import { useUserByIdQuery } from "../../../__generated__/types-and-hooks";
import UserAvatar from "../../../components/UserAvatar";

export function ConversationListItemSkeleton() {
  return (
    <Stack direction="row">
      <Skeleton animation="wave" variant="circular" width={42} height={42} />
      <Box sx={{ flex: 1, ml: 2 }}>
        <Typography level="title-sm">
          <Skeleton animation="wave">Full Name</Skeleton>
        </Typography>
        <Typography level="body-sm">
          <Skeleton animation="wave">Slug</Skeleton>
        </Typography>
      </Box>
    </Stack>
  );
}

export interface ConversationListItemProps {
  userId: number;
}

export default function ConversationListItem({
  userId,
}: ConversationListItemProps) {
  const userByIdQuery = useUserByIdQuery({ variables: { id: userId } });
  const user = userByIdQuery.data?.user_by_id;

  if (userByIdQuery.loading) {
    return <ConversationListItemSkeleton />;
  }

  return (
    <Stack direction="row">
      <UserAvatar userId={userId} size="md" />
      <Box sx={{ flex: 1, ml: 2 }}>
        <Typography level="title-sm">
          {user?.firstName} {user?.lastName}
        </Typography>
        <Typography level="body-sm">{user?.slug}</Typography>
      </Box>
    </Stack>
  );
}
